import React, { Component } from "react";
import Select from '../../../../components/Select'
import { InputGroup, Input, InputGroupAddon, Button } from 'reactstrap'
import { DateRangePicker } from 'react-date-range'
import auth from '../../../../utils/auth'
import cfg from '../../../../utils/config'
import axios from 'axios'
import * as rdrLocales from 'react-date-range/dist/locale'
import pdfMake from 'pdfmake'
import CsvDownloader from 'react-csv-downloader'
import ReactLoading from 'react-loading'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import helper from '../../../../utils/helper'
import { getClientesModulo, createOptionsClientes } from '../../../../services/clientes'

pdfMake.fonts = {
    Roboto: {
        normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
    }
}

const getBase64ImageFromURL = (url) => {
    return new Promise((resolve, reject) => {
       let img = new Image()
       img.setAttribute("crossOrigin", "anonymous")

       img.onload = () => {
          let canvas = document.createElement("canvas")
          canvas.width = img.width
          canvas.height = img.height

          let ctx = canvas.getContext("2d")
          ctx.drawImage(img, 0, 0)

          let dataURL = canvas.toDataURL("image/png")

          resolve(dataURL)
       }

       img.onerror = error => reject(error)

       img.src = url
    })
 }

class Form extends Component {
    state = {
        detalhes: { cliente: null, monitorado: null, tipo: { label: 'Vazão', value: 'vazao' }, volume: null, vazao: null, horimetro: null, periodo: null, inicio: null, fim: null },
        validacao: { periodo: true, cliente: true, monitorado: true, tipo: true, volume: true, horimetro: true, vazao: true, inicio: true, fim: true },
        monitorados: [],
        equipamentos: [],
        clientes: [],
        volumes: [],
        vazoes: [],
        niveis: [],
        horimetros: [],
        dataFormatada: "",
        datePickerShow: false,
        dateRange: { startDate: new Date(), endDate: new Date(), key: 'selection' },
        exportar_disabled: true,
        maior: false,
        carregando: false,
        csv: { data: [], columns: [] },
        relatorioGerado: false,
        modal: false,
        msg_erro: "",
        isCliente: auth.getUserInfo()?.cliente,
        info: {
            maior_que_900: "Com essa configuração e com base no periodo selecionado irá retornar apenas os valores em que o volume captado é maior que 900m³/dia"
        }
    }

    componentDidMount() {
        const { isCliente, detalhes } = this.state

        if (isCliente) {
            this.getMonitorado()
            delete detalhes.cliente
            this.setState({ detalhes })
        } else {
            this.getClientes()
        }
    }

    getClientes = async () => {
        await getClientesModulo('ambiental').then((clientes) => this.setState({ clientes: [...this.state.clientes, ...createOptionsClientes(clientes)] }) )
    }

    getMonitorado = (id_cliente) => {
        let userInfo = auth.getUserInfo()
        let bodyFormData = new FormData()

        bodyFormData.append('cliente_id', id_cliente ?? userInfo.id)

        axios({
            method: 'POST',
            url: cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/monitorado/filtro/',
            data: bodyFormData,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        }).then((response) => {
            let optionsMonitorado = []
            response.data.forEach((c) => {
                optionsMonitorado.push({ "value": c.id, "label": c.nome })
            })
            this.setState({ monitorados: optionsMonitorado })
        })
            .catch(error => console.log(error))
    }

    handleChangeCliente = (selectedOption, field) => {
        let obj = this.state.detalhes
        obj[field] = selectedOption.value

        this.getMonitorado(selectedOption.value)
    }

    handleChangeMonitorado = (selectedOption, field) => {
        let obj = this.state.detalhes
        obj[field] = selectedOption.value

        let userInfo = auth.getUserInfo()

        axios({
            method: 'GET',
            url: cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/monitorado-parametro/?limit=100&monitorado=${selectedOption.value}`,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        })
            .then((res) => {
                let optionsItem = []

                res.data.results.forEach((field) => {
                    optionsItem.push({ label: field.campo.descricao, value: field.campo.id, id: field.campo.identificacao })
                })

                this.setState({ volumes: optionsItem, vazoes: optionsItem, horimetros: optionsItem, niveis: optionsItem, detalhes: obj })
            }).catch(console.error)
    }

    handleChangeSelect = (selectedOption, field) => {
        let optionObj = Object.assign({}, this.state.detalhes)
        let validacao = Object.assign({}, this.state.validacao)

        optionObj[field] = selectedOption

        if (field === 'tipo') {
            let delete_field = selectedOption.value === 'vazao' ? 'nivel' : 'vazao'

            delete optionObj?.[delete_field]
            delete validacao?.[delete_field]

            optionObj[selectedOption.value] = null
            validacao[selectedOption.value] = true
        }

        this.setState({ detalhes: optionObj, validacao: validacao })
    }

    handleChangeHora = (e) => {
        let detalhes = Object.assign({}, this.state.detalhes)

        detalhes[e.target.id] = e.target.value

        this.setState({ detalhes: detalhes })
    }

    handleChangePeriodo = (ranges) => {
        let detalhes = Object.assign({}, this.state.detalhes)

        detalhes["periodo"] = ranges.selection.startDate.toLocaleDateString() + "-" + ranges.selection.endDate.toLocaleDateString()
        this.setState({
            dateRange: {
                startDate: ranges.selection.startDate,
                endDate: ranges.selection.endDate,
                key: 'selection',
            },
            dataFormatada: ranges.selection.startDate.toLocaleDateString() + " - " + ranges.selection.endDate.toLocaleDateString(),
            detalhes: detalhes
        })
    }

    showDatePicker = () => {
        this.setState({ datePickerShow: !this.state.datePickerShow })
    }

    gerarRelatorio = (e) => {
        e.preventDefault()

        const { detalhes, maior } = this.state
        let validacao = Object.assign({}, this.state.validacao)
        let erro = false

        for (let i in detalhes) {
            if (detalhes[i] === null) {
                validacao[i] = false
                erro = true
            } else {
                validacao[i] = true
            }
        }

        this.setState({ validacao: validacao })

        if (erro) {
            return
        }

        this.setState({ carregando: true, exportar_disabled: true })

        let userInfo = auth.getUserInfo()
        let bodyFormData = new FormData()

        let periodo = detalhes.periodo.split("-")

        bodyFormData.append('horimetro', JSON.stringify(detalhes.horimetro))
        bodyFormData.append('volume', JSON.stringify(detalhes.volume))
        bodyFormData.append('tipo', detalhes.tipo.value)
        bodyFormData.append('data_inicio', periodo[0].replaceAll("/", "-"))
        bodyFormData.append('data_fim', periodo[1].replaceAll("/", "-"))
        bodyFormData.append('hora_inicio', detalhes.inicio)
        bodyFormData.append('hora_fim', detalhes.fim)
        bodyFormData.append('m900', maior)

        if (detalhes.tipo.value === "vazao") {
            bodyFormData.append('vazao', JSON.stringify(detalhes.vazao))
        } else {
            bodyFormData.append('nivel', JSON.stringify(detalhes.nivel))
        }

        axios({
            method: 'POST',
            url: cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/relatorio-ambiental-inema/',
            data: bodyFormData,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        })
            .then((response) => {
                this.formatarCsv(response)
            })
            .catch(error => {
                this.setState({ carregando: false, exportar_disabled: true })
            })
    }

    formatarCsv = (response) => {
        this.setState({ carregando: false, exportar_disabled: false, relatorioGerado: true })

        const { detalhes } = this.state
        let reportes = response.data
        let csv = { data: [], columns: [] }

        const tipo = detalhes?.tipo?.value

        const baseCols = [
            { id: 'c0', displayName: 'Data' },
            { id: 'c1', displayName: 'Hora Inicial' },
            { id: 'c2', displayName: 'Volume Inicial' },
            { id: 'c3', displayName: 'Horímetro Inicial' },
            { id: 'c4', displayName: 'Hora Final' },
            { id: 'c5', displayName: 'Volume Final' },
            { id: 'c6', displayName: 'Horímetro Final' },
            { id: 'c7', displayName: 'Volume Captado' },
            { id: 'c8', displayName: 'Tempo Operação' }
        ]

        csv.columns = [...baseCols]

        if (tipo === 'vazao') {
            csv.columns.push({ id: 'c9', displayName: 'Vazão Média' })
        } else if (tipo === 'nivel') {
            csv.columns.push({ id: 'c10', displayName: 'Nível Mínimo' })
            csv.columns.push({ id: 'c11', displayName: 'Nível Máximo' })
            csv.columns.push({ id: 'c12', displayName: 'Nível Médio' })
        } else {
            csv.columns.push({ id: 'c9', displayName: 'Vazão Média' })
        }

        let hasIncons = false
        for (let d in reportes) {
            if (reportes[d] && reportes[d].inconsistencias) { hasIncons = true; break }
        }

        if (hasIncons) {
            csv.columns.push({ id: 'c_incons', displayName: 'Inconsistências' })
        }

        for (let data in reportes) {
            let item = reportes[data]
            let row = {}

            csv.columns.forEach(col => {
                switch (col.id) {
                    case 'c0': row.c0 = data; break
                    case 'c1': row.c1 = item.hora_inicio; break
                    case 'c2': row.c2 = item.volume_inicial; break
                    case 'c3': row.c3 = item.horimetro_inicial; break
                    case 'c4': row.c4 = item.hora_fim; break
                    case 'c5': row.c5 = item.volume_final; break
                    case 'c6': row.c6 = item.horimetro_final; break
                    case 'c7': row.c7 = item.volume_captado; break
                    case 'c8': row.c8 = item.tempo_operacao; break
                    case 'c9':
                        if (tipo === 'vazao' || !tipo) row.c9 = item.vazao_media
                        else row.c9 = ''
                        break
                    case 'c10':
                        if (tipo === 'vazao' || !tipo) row.c10 = ''
                        else row.c10 = item.nivel_min
                        break
                    case 'c11':
                        if (tipo === 'nivel') row.c11 = item.nivel_max
                        else row.c11 = ''
                        break
                    case 'c12':
                        if (tipo === 'nivel') row.c12 = item.nivel_medio
                        else row.c12 = ''
                        break
                    case 'c_incons': row.c_incons = item.inconsistencias ? (Array.isArray(item.inconsistencias) ? item.inconsistencias.join(', ') : String(item.inconsistencias)) : ''; break
                    default: row[col.id] = item[col.id] || ''; break
                }
            })

            csv.data.push(row)
        }

        this.setState({ csv: csv })
    }

    exportarPDF = async () => {
        const infoEmpresa = auth.getUserInfo()
        const { csv } = this.state

        const colKeys = csv.columns.map(c => c.id)
        const tableBody = [
            csv.columns.map(col => ({ text: col.displayName, style: 'tableHeader' })),
            ...csv.data.map(item => colKeys.map(key => ({ text: String(item[key] ?? ''), style: 'tableBody' })))
        ]
        const widths = colKeys.map(() => '*')

        let monitoradoSelecionado = this.state.monitorados.find(monitorado => monitorado.value === this.state.detalhes.monitorado)
        let periodoSelecionado = this.state.detalhes.periodo

        const pdfOptions = {
            pageOrientation: 'landscape',
            pageMargins: [40, 50, 40, 50],
            defaultStyle: { fontSize: 10 },
            styles: { header: { fontSize: 14, bold: true }, tableHeader: { bold: true, fontSize: 8 }, tableBody: { fontSize: 7 } },
            content: [
                {
                    table: {
                        widths: ['*', 80],
                        body: [
                            [
                                {
                                    text: ['\n', '\n', infoEmpresa.email, '\n', 'Monitorado: ' + monitoradoSelecionado.label, '\n', 'Período: ' + periodoSelecionado],
                                    border: [false, false, false, true]
                                },
                                { image: 'logo', width: 80, border: [false, false, false, true] }
                            ]
                        ],
                    },
                },
                '\n\n\n',
                { text: 'Relatório Inema', style: 'header', alignment: 'center' },
                '\n',
                { table: { widths, body: tableBody, layout: 'lightHorizontalLines' } }
            ],
            images: { logo: await getBase64ImageFromURL(document.querySelector('div.hdv-logomarca img')?.src) },
        }

        const win = window.open('', '_blank')
        pdfMake.createPdf(pdfOptions).open({}, win)
    }


    render() {
        const { clientes, monitorados, volumes, vazoes, niveis, horimetros, exportar_disabled, maior, validacao, detalhes, relatorioGerado, csv, msg_erro, isCliente, info } = this.state

        return (
            <div className="hdv-render-div" style={{ marginBottom: '65px' }}>

                <Modal isOpen={this.state.modal} toggle={() => this.setState({ modal: false })}>
                    <ModalHeader toggle={() => this.setState({ modal: false })} >Aviso</ModalHeader>
                    <ModalBody>
                        <strong>{msg_erro}</strong>
                    </ModalBody>
                    <ModalFooter>
                        <button onClick={() => this.setState({ modal: false })} className="hdv-btn-forms hdv-btn-red">Fechar</button>
                    </ModalFooter>
                </Modal>

                <div className="col-md-12 hdv-bloco-top-space hdv-zera-padding-left-right-boostrap">
                    <div>
                        <div className="hdv-default-header mx-3">
                            <span className="screen-menu-desc">
                                <h4>Relatório Inema</h4>
                                <div className="gray-background">
                                    <i className="fa fa-file-alt fa-2x"></i>
                                </div>
                            </span>
                            <ReactLoading className="hdv-report-loading" type="cylon" color={this.state.carregando ? "var(--background-menu)" : "transparent"} width={50} />
                        </div>

                        <details open={true} className='custom-summary'>
                            <summary>Filtros</summary>
                            <form style={{ padding: "20px" }} className="hdv-form-default">
                                <div className="row">
                                    <div style={{ display: isCliente ? "none" : "block" }} className="col-md-4">
                                        <label className="required mt-0">Cliente</label>
                                        <Select
                                            name="cliente"
                                            options={clientes}
                                            onChange={(e) => { this.handleChangeCliente(e, "cliente") }}
                                        />
                                        {!validacao.cliente ? <span id='validacao-descricao'>Campo Obrigatório</span> : null}
                                    </div>
                                    <div className="col-md-4">
                                        <label className="required mt-0">Monitorado</label>
                                        <Select
                                            name="monitorado"
                                            options={monitorados}
                                            onChange={(e) => this.handleChangeMonitorado(e, 'monitorado')}
                                        />
                                        {!validacao?.monitorado ? <span id='validacao-descricao'>Campo Obrigatório</span> : null}
                                    </div>
                                    <div className="col-md-4">
                                        <label className="required mt-0">Tipo</label>
                                        <Select
                                            name="tipo"
                                            value={[
                                                'vazao' in detalhes ?
                                                    { label: "Vazão", value: "vazao" }
                                                    :
                                                    { label: "Nível", value: "nivel" }
                                            ]}
                                            options={[
                                                { label: "Vazão", value: "vazao" },
                                                { label: "Nível", value: "nivel" }
                                            ]}
                                            onChange={(e) => this.handleChangeSelect(e, 'tipo')}
                                        />
                                        {!validacao.tipo ? <span id='validacao-descricao'>Campo Obrigatório</span> : null}
                                    </div>
                                </div>

                                <br />

                                <div className="row">
                                    
                                    {
                                        'vazao' in detalhes ?

                                            <div className="col-md-4">
                                                <label className="required mt-0">Vazão</label>
                                                <Select
                                                    name="vazao"
                                                    options={vazoes}
                                                    value={detalhes.vazao}
                                                    onChange={(e) => this.handleChangeSelect(e, 'vazao')}
                                                />
                                                {!validacao.vazao ? <span id='validacao-descricao'>Campo Obrigatório</span> : null}
                                            </div>

                                            : 'nivel' in detalhes ?

                                                <div className="col-md-4">
                                                    <label className="required mt-0">Nível</label>
                                                    <Select
                                                        name="nivel"
                                                        options={niveis}
                                                        value={detalhes.nivel}
                                                        onChange={(e) => this.handleChangeSelect(e, 'nivel')}
                                                    />
                                                    {!validacao.nivel ? <span id='validacao-descricao'>Campo Obrigatório</span> : null}
                                                </div>
                                                : ""
                                    }

                                    <div className="col-md-4">
                                        <label className="required mt-0">Volume</label>
                                        <Select
                                            name="volume"
                                            options={volumes}
                                            onChange={(e) => this.handleChangeSelect(e, 'volume')}
                                        />
                                        {!validacao.volume ? <span id='validacao-descricao'>Campo Obrigatório</span> : null}
                                    </div>

                                    <div className="col-md-4">
                                        <label className="required mt-0">Horimetro</label>
                                        <Select
                                            name="horimetro"
                                            options={horimetros}
                                            onChange={(e) => this.handleChangeSelect(e, 'horimetro')}
                                        />
                                        {!validacao.horimetro ? <span id='validacao-descricao'>Campo Obrigatório</span> : null}
                                    </div>
                                </div>

                                <br />

                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="required mt-0">Periodo</label>
                                        <InputGroup className="hdv-force-hight">
                                            <Input className="hdv-force-hight" placeholder="Selecione o periodo" onChange={() => false} disabled value={this.state.dataFormatada} />
                                            <InputGroupAddon addonType="append">
                                                <Button onClick={this.showDatePicker} color={(this.state.datePickerShow) ? "danger" : "primary"}>
                                                    <i className={(this.state.datePickerShow) ? "fa fa-calendar-times-o" : "fa fa-calendar-check-o"}></i>
                                                    {(this.state.datePickerShow) ? "Fechar Calendário" : "Exibir Calendário"}
                                                </Button>
                                            </InputGroupAddon>
                                        </InputGroup>
                                        {!validacao.periodo ? <span id='validacao-periodo'>Campo Obrigatório</span> : null}
                                        <div style={{ position: "initial" }} className={(this.state.datePickerShow) ? "hdv-datepicker" : "hdv-datepicker-display-none"}>
                                            <DateRangePicker 
                                                locale={rdrLocales.pt} 
                                                ranges={[this.state.dateRange]} 
                                                onChange={this.handleChangePeriodo}
                                                maxDate={new Date()}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="required mt-0">Início</label>
                                        <input onChange={(e) => this.handleChangeHora(e)} id="inicio" type="time" style={{width: "100%"}}/>
                                        {!validacao.inicio ? <span id='validacao-descricao'>Campo Obrigatório</span> : null}
                                    </div>
                                    <div className="col-md-2">
                                        <label className="required mt-0">Fim</label>
                                        <input onChange={(e) => this.handleChangeHora(e)} id="fim" type="time" style={{width: "100%"}}/>
                                        {!validacao.fim ? <span id='validacao-descricao'>Campo Obrigatório</span> : null}
                                    </div>
                                    <div className="col-md-2">
                                        <label className="required mt-0">Maior que 900m³/dia <i className="las la-info-circle" data-toggle="tooltip" data-placement="top" title={info.maior_que_900} style={{cursor: "pointer"}} onClick={() => helper.dispatchEvent("showAviso", {message: info.maior_que_900})}></i></label>
                                        <input onChange={(e) => this.setState({ maior: e.target.checked })} defaultChecked={maior} type="checkbox" />
                                    </div>
                                </div>
                            </form>
                        </details>
                    </div>

                    <div style={{ display: 'flex' }} className="hdv-btn-group">
                        <button onClick={this.gerarRelatorio} className="hdv-btn-forms hdv-btn-blue">Gerar Relatório</button>

                        <CsvDownloader
                            style={{ border: 'none' }}
                            columns={this.state.csv.columns}
                            datas={this.state.csv.data}
                            filename={`relatorio_inema.csv`}
                            separator=";">
                            <button disabled={exportar_disabled} className="hdv-btn-forms hdv-btn-green ">
                                Exportar CSV
                            </button>
                        </CsvDownloader>

                        <button onClick={this.exportarPDF} disabled={exportar_disabled} className="hdv-btn-forms hdv-btn-red">Exportar PDF</button>
                    </div>

                    {
                        relatorioGerado ?
                            <section id="hdv-multi-report-print" className="mb-4">
                                <br />
                                <h5 style={{ textAlign: 'center', fontWeight: 'bold' }}>Relatório Inema</h5>
                                <br />

                                <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: '600px', maxWidth: '100%' }}>
                                <table className="table afira-table">
                                    <thead>
                                        <tr>
                                            {
                                                csv.columns.map((item, key) => {
                                                    return (
                                                        <th key={key}>{item.displayName}</th>
                                                    )
                                                })
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            csv.data.map((item, key) => {
                                                return (
                                                    <tr key={key}>
                                                        {csv.columns.map((col, idx) => (
                                                            <td key={idx}>{item[col.id]}</td>
                                                        ))}
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                                </div>
                            </section>
                            : ''
                    }
                </div>
            </div>
        )
    }
}

export default Form